import { useQuery } from '@apollo/client';
import { CITRIN_GET_VEHICULE_PROBLEMS, GetVehiculeProblemsRequest, GetVehiculeProblemsResponse } from '..';

export const useGetVehiculeProblemQuery = () => {
    const { data, previousData, ...rest } = useQuery<GetVehiculeProblemsResponse, GetVehiculeProblemsRequest>(
        CITRIN_GET_VEHICULE_PROBLEMS
    );

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getAllVehiculesProblems,
        data: data?.CITRIN_MGT_getAllVehiculesProblems ?? [],
    };
};
